module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "id": "pgepubid00010"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('table', {
    staticClass: "calibre5",
    attrs: {
      "cellpadding": "1",
      "cellspacing": "0",
      "summary": "Table of Contents"
    }
  }, [_c('tbody', {
    staticClass: "calibre6"
  }, [_c('tr', {
    staticClass: "calibre7"
  }, [_c('td', {
    staticClass: "calibre8"
  }, [_vm._v("I.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre9"
  }, [_c('em', {
    staticClass: "smcap"
  }, [_vm._v("Into the Woods")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre8"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0004"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre7"
  }, [_c('td', {
    staticClass: "calibre8"
  }, [_vm._v("II.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre9"
  }, [_c('em', {
    staticClass: "smcap"
  }, [_vm._v("Mr. Croyden Keeps His Promise")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre8"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0005"
    }
  }, [_vm._v("31")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre7"
  }, [_c('td', {
    staticClass: "calibre8"
  }, [_vm._v("III.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre9"
  }, [_c('em', {
    staticClass: "smcap"
  }, [_vm._v("Theo Meets with a Calamity")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre7"
  }, [_c('td', {
    staticClass: "calibre8"
  }, [_vm._v("IV.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre9"
  }, [_c('em', {
    staticClass: "smcap"
  }, [_vm._v("Mr. Croyden's Story")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre7"
  }, [_c('td', {
    staticClass: "calibre8"
  }, [_vm._v("V.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre9"
  }, [_c('em', {
    staticClass: "smcap"
  }, [_vm._v("The Potter Who Burned His Chairs")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre7"
  }, [_c('td', {
    staticClass: "calibre8"
  }, [_vm._v("VI.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre9"
  }, [_c('em', {
    staticClass: "smcap"
  }, [_vm._v("From Vases to Drain-Pipes")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre7"
  }, [_c('td', {
    staticClass: "calibre8"
  }, [_vm._v("VII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre9"
  }, [_c('em', {
    staticClass: "smcap"
  }, [_vm._v("Porcelain at Last")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre7"
  }, [_c('td', {
    staticClass: "calibre8"
  }, [_vm._v("VIII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre9"
  }, [_c('em', {
    staticClass: "smcap"
  }, [_vm._v("The Third Famous Potter")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("129")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre7"
  }, [_c('td', {
    staticClass: "calibre8"
  }, [_vm._v("IX.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre9"
  }, [_c('em', {
    staticClass: "smcap"
  }, [_vm._v("The Romance of French China-Making")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("149")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre7"
  }, [_c('td', {
    staticClass: "calibre8"
  }, [_vm._v("X.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre9"
  }, [_c('em', {
    staticClass: "smcap"
  }, [_vm._v("How the Italians Made China")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("160")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre7"
  }, [_c('td', {
    staticClass: "calibre8"
  }, [_vm._v("XI.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre9"
  }, [_c('em', {
    staticClass: "smcap"
  }, [_vm._v("Our English Cousins")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("173")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre7"
  }, [_c('td', {
    staticClass: "calibre8"
  }, [_vm._v("XII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre9"
  }, [_c('em', {
    staticClass: "smcap"
  }, [_vm._v("Theo Makes a Present")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("193")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre7"
  }, [_c('td', {
    staticClass: "calibre8"
  }, [_vm._v("XIII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre9"
  }, [_c('em', {
    staticClass: "smcap"
  }, [_vm._v("The Trenton Visit")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("210")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre7"
  }, [_c('td', {
    staticClass: "calibre8"
  }, [_vm._v("XIV.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre9"
  }, [_c('em', {
    staticClass: "smcap"
  }, [_vm._v("The Beginning of the Porcelain Pilgrimage")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("223")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre7"
  }, [_c('td', {
    staticClass: "calibre8"
  }, [_vm._v("XV.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre9"
  }, [_c('em', {
    staticClass: "smcap"
  }, [_vm._v("How Porcelain is Made")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("235")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre7"
  }, [_c('td', {
    staticClass: "calibre8"
  }, [_vm._v("XVI.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre9"
  }, [_c('em', {
    staticClass: "smcap"
  }, [_vm._v("Dishes, Dishes Everywhere!")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("246")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre7"
  }, [_c('td', {
    staticClass: "calibre8"
  }, [_vm._v("XVII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre9"
  }, [_c('em', {
    staticClass: "smcap"
  }, [_vm._v("The Decoration of China")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("260")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre7"
  }, [_c('td', {
    staticClass: "calibre8"
  }, [_vm._v("XVIII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre9"
  }, [_c('em', {
    staticClass: "smcap"
  }, [_vm._v("Theo's Great Choice")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre8"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("281")])])])])]), _vm._v(" "), _c('p', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('a', {
    attrs: {
      "id": "png007"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "png008"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('a', {
    attrs: {
      "id": "png009"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "png010"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dfd2e92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0003.vue
// module id = 63
// module chunks = 0